// @ts-nocheck
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { Close } from "@mui/icons-material";
import GenericTransparentBtn from "../../../../components/Custom/GenericTransparentBtn";
import PropTypes from "prop-types";
import { UserIdFetchDropdown } from "../../../../components/Custom/UserIdDropdown";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getUniversalDateTimeFormat } from "../../../../appCalcutions";
import { getPositionNameWithSuffix } from "../../../../utils/methods/formatters";

const style = {
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  maxHeight: "90vh",
  maxWidth: "90vw",
};

export default function SelectConPosForReimb({
  open,
  onClose,
  onSelect,
  title,
  buttonText,
  selectedContractor = null,
  positionList = null,
}) {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { positions } = useSelector((state) => state?.eventRequestDetails);
  const [selectedValues, setSelectedValues] = useState({
    selectedContractor: null,
    selectedPosition: null,
  });
  const [error, setError] = useState(null);

  const contractorOptions = useMemo(() => {
    let contractorSet = new Set();
    let contractor = [];
    Object.entries(positions)?.forEach(([key, posArr]) => {
      posArr
        ?.filter((p) => !p?.isBackupPosition)
        ?.filter((p) =>
          selectedValues?.selectedPosition?._id
            ? p?._id == selectedValues?.selectedPosition?._id
            : true,
        )
        ?.forEach((pos) => {
          if (
            pos?.assignedContractor &&
            !contractorSet.has(pos?.assignedContractor)
          ) {
            contractorSet.add(pos?.assignedContractor);
            contractor.push({
              name: pos?.preferredName || pos?.contractorName,
              _id: pos?.assignedContractor,
              hoverDetails: {
                contractorId: pos?.assignedContractor,
                email: pos?.email,
                name: pos?.contractorName,
                preferredName: pos?.preferredName,
                phone: pos?.mobile,
                mobile: pos?.mobile,
                contractorType: pos?.contractorType,
                state: pos?.state,
                city: pos?.city,
                smsOptedOut: pos?.smsOptedOut,
                smsConsentStatusBySms: pos?.smsConsentStatusBySms,
                smsPermissionStatus: pos?.smsPermissionStatus,
              },
            });
          }
        });
    });

    return contractor;
  }, [positions, selectedValues]);

  const positionOptions = useMemo(() => {
    let positionSet = new Set();
    let positionsArr = [];

    if (positionList) {
      positionList
        ?.filter((p) => !p?.isBackupPosition)
        ?.forEach((pos) => {
          if (pos?._id && !positionSet.has(pos?._id)) {
            // early return if selected contractor is there;
            if (!selectedValues?.selectedContractor) {
              positionSet.add(pos?._id);
              positionsArr.push({
                name: `${pos?.positionName}${pos?.positionOrder ? `-${pos?.positionOrder}` : ""} - ${getUniversalDateTimeFormat({ dateTime: pos?.startDate })} - ${pos?.preferredName || pos?.contractorName || "N/A"}`,
                _id: pos?._id,
                positionName: pos?.positionName,
                contractorName: pos?.preferredName || pos?.contractorName,
                contractorId: pos?.assignedContractor,
                positionOrder: pos?.positionOrder,
                startDate: pos?.startDate,
              });
            } else {
              if (
                selectedValues?.selectedContractor &&
                selectedValues?.selectedContractor?._id ==
                  pos?.assignedContractor
              ) {
                positionSet.add(pos?._id);
                positionsArr.push({
                  name: `${getPositionNameWithSuffix({ pos })} - ${getUniversalDateTimeFormat({ dateTime: pos?.startDate })} - ${pos?.preferredName || pos?.contractorName || "N/A"}`,
                  _id: pos?._id,
                  positionName: pos?.positionName,
                  positionOrder: pos?.positionOrder,
                  startDate: pos?.startDate,
                  contractorName:
                    (pos?.preferredName || pos?.contractorName) ?? null,
                  contractorId: pos?.assignedContractor ?? null,
                });
              }
            }
          }
        });

      return positionsArr;
    }
    Object.entries(positions)?.forEach(([key, posArr]) => {
      posArr
        ?.filter((p) => !p?.isBackupPosition)
        ?.forEach((pos) => {
          if (pos?._id && !positionSet.has(pos?._id)) {
            // early return if selected contractor is there;
            if (!selectedValues?.selectedContractor) {
              positionSet.add(pos?._id);
              positionsArr.push({
                name: `${pos?.positionName}${pos?.positionOrder ? `-${pos?.positionOrder}` : ""} - ${getUniversalDateTimeFormat({ dateTime: pos?.startDate })} - ${pos?.preferredName || pos?.contractorName || "N/A"}`,
                _id: pos?._id,
                positionName: pos?.positionName,
                contractorName: pos?.preferredName || pos?.contractorName,
                contractorId: pos?.assignedContractor,
                positionOrder: pos?.positionOrder,
                startDate: pos?.startDate,
              });
            } else {
              if (
                selectedValues?.selectedContractor &&
                selectedValues?.selectedContractor?._id ==
                  pos?.assignedContractor
              ) {
                positionSet.add(pos?._id);
                positionsArr.push({
                  name: `${getPositionNameWithSuffix({ pos })} - ${getUniversalDateTimeFormat({ dateTime: pos?.startDate })} - ${pos?.preferredName || pos?.contractorName || "N/A"}`,
                  _id: pos?._id,
                  positionName: pos?.positionName,
                  positionOrder: pos?.positionOrder,
                  startDate: pos?.startDate,
                  contractorName:
                    (pos?.preferredName || pos?.contractorName) ?? null,
                  contractorId: pos?.assignedContractor ?? null,
                });
              }
            }
          }
        });
    });
    return positionsArr;
  }, [positions, selectedValues?.selectedContractor, positionList]);

  useEffect(() => {
    if (selectedContractor?._id) {
      setSelectedValues({
        selectedPosition: null,
        selectedContractor: {
          ...selectedContractor,
        },
      });
    }
  }, [selectedContractor]);

  function handleClose() {
    onClose();
  }

  return (
    <Modal
      open={open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") handleClose(e);
      }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
        }}
      >
        <Box
          sx={{
            ...style,
            height: "auto",
            width: "600px",
            overflowY: "auto",
            minWidth: isMediumScreen ? "0" : "600px",
            "@media (max-width: 600px)": {
              maxHeight: "97vh",
              maxWidth: "95vw",
            },
            "@media (max-width: 900px)": {
              overflowY: "auto",
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              right: "0",
              transform: `translate(50%, -50%)`,
            }}
          >
            <GenericTransparentBtn
              onClick={() => {
                handleClose();
              }}
              style={{
                background: "grey",
                padding: "0.10rem",
                borderRadius: "50%",
                onHover: {
                  background: "grey",
                  padding: "0.10rem",
                },
              }}
            >
              <Close
                sx={{
                  fontSize: "2rem",
                }}
              />
            </GenericTransparentBtn>
          </Box>

          <Typography
            my={2}
            sx={{
              mx: "auto",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "1.75rem",
              color: getCssVariableHandler({
                variableName: "--primary-blue-rgb",
              }),
            }}
          >
            {title || "Add Reimbursement"}
          </Typography>

          <Grid container>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: "500",
                }}
              >
                Select Position*
              </Typography>
              <UserIdFetchDropdown
                name={selectedValues?.selectedPosition?.name || null}
                userId={selectedValues?.selectedPosition?._id || null}
                placeholder={"Select Position"}
                unCleanable={false}
                fixOptions={positionOptions}
                onChange={(newValue) => {
                  setSelectedValues((prev) => ({
                    ...prev,
                    ...(newValue?.contractorId
                      ? {
                          selectedContractor: {
                            _id: newValue?.contractorId,
                            name: newValue?.contractorName,
                          },
                        }
                      : {
                          selectedContractor: null,
                        }),
                    selectedPosition: {
                      _id: newValue?._id,
                      name: newValue?.name,
                      positionName: `${newValue?.positionName} ${newValue?.positionOrder ? `- ${newValue?.positionOrder}` : ""}`,
                      startDate: newValue?.startDate,
                    },
                  }));
                }}
                fontSize={"18px"}
              />

              {error ? (
                <Typography
                  sx={{
                    textAlign: "center",
                    color: getCssVariableHandler({
                      variableName: "--red-shade-1rgb",
                    }),
                  }}
                >
                  {error}
                </Typography>
              ) : null}
            </Grid>

            {!selectedContractor?._id && (
              <Grid item xs={12} mt={2} mb={1}>
                <Typography
                  sx={{
                    fontWeight: "500",
                    mb: 1,
                  }}
                >
                  Select Contractor
                </Typography>
                <UserIdFetchDropdown
                  name={selectedValues?.selectedContractor?.name || null}
                  userId={selectedValues?.selectedContractor?._id || null}
                  placeholder={"Select Contractor"}
                  fixOptions={contractorOptions}
                  unCleanable={false}
                  onChange={(newValue) => {
                    // newValue = {name, _id}
                    setSelectedValues((prev) => ({
                      selectedContractor: newValue?._id
                        ? {
                            _id: newValue?._id,
                            name: newValue?.name,
                          }
                        : null,
                      ...(prev?.selectedContractor?._id == newValue?._id
                        ? {
                            selectedPosition: prev?.selectedPosition,
                          }
                        : {
                            selectedPosition: null,
                          }),
                    }));
                  }}
                  fontSize={"18px"}
                />
              </Grid>
            )}
          </Grid>

          <Box
            className="bottomButton"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              width: "100%",
            }}
          >
            <Button
              className="btnPink"
              sx={{
                width: "auto !important",
              }}
              onClick={() => {
                if (!selectedValues?.selectedPosition) {
                  setError("Position selection is required");
                  const timeout = setTimeout(() => {
                    setError(null);
                    clearTimeout(timeout);
                  }, 5000);
                  return;
                }
                onSelect({
                  contractor: selectedValues?.selectedContractor,
                  pos: selectedValues?.selectedPosition,
                });
              }}
            >
              <Typography className="btn-text">
                {buttonText ? buttonText : "Create Reimbursement"}{" "}
              </Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

SelectConPosForReimb.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  selectedContractor: PropTypes.object,
  positionList: PropTypes.array,
};